"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clear = exports.remove = exports.put = exports.get = void 0;
const get = (itemName) => {
    const serializedData = localStorage.getItem(itemName.toString());
    if (serializedData === null || serializedData === undefined)
        return undefined;
    return JSON.parse(serializedData);
};
exports.get = get;
const put = (itemName, data) => {
    localStorage.setItem(itemName.toString(), JSON.stringify(data));
    return { [itemName]: data };
};
exports.put = put;
const remove = (itemName) => localStorage.removeItem(itemName.toString());
exports.remove = remove;
const clear = () => localStorage.clear();
exports.clear = clear;
